var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSection5Column4Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_505_2400)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 36,
    r: 34,
    fill: "#272D3A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_505_2400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5001 19C31.4171 19 24.0557 26.3943 24.0557 35.5179C24.0557 44.6414 31.4171 52.0357 40.5001 52.0357C49.5831 52.0357 56.9446 44.6414 56.9446 35.5179C56.9446 26.3943 49.5831 19 40.5001 19ZM45.7739 37.6794C45.8702 37.6149 45.9666 37.5826 46.0758 37.5826H46.8537C47.0559 37.5826 47.2427 37.7116 47.3282 37.9052L47.6705 38.7279C47.7094 38.8247 47.8027 38.8892 47.9038 38.8892H48.1528C48.2616 38.8892 48.3628 38.8166 48.3939 38.7037L48.6661 37.7681C48.6966 37.6665 48.7994 37.5826 48.915 37.5826H49.304C49.444 37.5826 49.5607 37.6955 49.5607 37.8407V38.6795C49.5607 38.8166 49.6151 38.9456 49.7085 39.0424L50.471 39.809C50.6654 40.0025 50.7744 40.2687 50.7744 40.5432V42.124C50.7744 42.2397 50.7452 42.3512 50.7088 42.4592C50.5549 42.6865 50.3856 42.9023 50.2176 43.1187L49.8643 43.471C49.673 43.6671 49.4097 43.7768 49.1334 43.7768H48.1635C47.8912 43.7768 47.6268 43.6639 47.4402 43.4703L46.6 42.6315C46.1722 42.204 45.5574 42.0347 44.9664 42.1798L43.6053 42.5267C43.5197 42.5428 43.4342 42.5508 43.3486 42.5508H42.6876C42.4154 42.5508 42.1509 42.446 41.9643 42.2524L41.1939 41.4862C41.1005 41.3894 41.0461 41.2523 41.0461 41.1152V40.4622C41.0461 40.2525 41.1705 40.059 41.3728 39.9783L43.8927 38.9621C44.025 38.9137 44.1417 38.8492 44.2583 38.7685L45.7739 37.6794ZM40.5001 22.0971C41.6988 22.0971 42.855 22.2712 43.9612 22.5699V22.6173C43.9612 23.259 43.6642 23.8639 43.1576 24.2549L41.2395 25.7344C40.9128 25.9522 40.9361 26.4442 41.2939 26.6216L41.9864 26.9765C42.3364 27.1458 42.5542 27.5088 42.5542 27.8959V32.9369C42.5542 33.2192 42.3286 33.4531 42.0409 33.4531H41.8464C41.652 33.4531 41.4731 33.3402 41.3874 33.1708C41.2863 32.9692 41.0063 32.9531 40.8896 33.1466L39.7693 35.0178C39.5815 35.3243 39.2475 35.5179 38.8878 35.5179H38.8685C38.5923 35.5179 38.3354 35.634 38.1426 35.8276L37.7765 36.1889C37.5821 36.3905 37.5821 36.7131 37.7765 36.9148L38.1421 37.2858C38.3365 37.4794 38.4455 37.7374 38.4455 38.0117V38.615C38.4455 39.1876 37.9865 39.6473 37.419 39.6473H37.0249C36.636 39.6473 36.2785 39.4296 36.107 39.0747L34.6482 36.1566C34.494 35.8405 34.0187 35.7759 33.826 36.0276L32.5798 37.2793C32.3871 37.4729 32.1237 37.5826 31.8475 37.5826H27.3137C27.2097 36.9051 27.139 36.2212 27.139 35.5179C27.139 28.1171 33.1322 22.0971 40.5001 22.0971Z",
    fill: "#FFCE71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_505_2400",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_505_2400"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_505_2400",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_505_2400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 33.0357,
    fill: "white",
    transform: "translate(22 19)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection5Column4Icon);
export default __webpack_public_path__ + "static/media/section-5-column-4-icon.3a60ac413c99c811268b7771ac3d8b04.svg";
export { ForwardRef as ReactComponent };